import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import moment from 'moment/moment';
import ExpenseDatePicker from './ExpenseDatePicker';
import { COLORS } from '../../../utils/Application_Constants';
import { ExpenseStatusValuesEnum } from './ExpenseStatus.enum';

const PayrollDate = (props) => {
    const {
        index,
        expense,
        isRequired = false,
        isViewOnly = false,
        isInvoiceReviewLocked = false,
    } = props;
    const { control, errors, getValues } = useFormContext();

    const minDate = moment(new Date()).startOf('day');
    const maxDate = moment(new Date()).startOf('day').add(30, 'days');

    return (
        <Grid2 item size={{ xs: 12, md: 6 }}>
            <Controller
                control={control}
                disabled={isViewOnly || isInvoiceReviewLocked}
                name={`expenseEntries[${index}].payrollDate`}
                defaultValue={expense.payrollDate || null}
                rules={{
                    validate: (value) => {
                        const currentStatus = getValues(`expenseEntries[${index}].status`);

                        if (currentStatus !== ExpenseStatusValuesEnum.Approved) {
                            return true;
                        }

                        if (!value || !moment(value).isValid()) {
                            return 'Payroll Date is required. Please enter a valid date.';
                        }

                        if (!moment(value).isSameOrAfter(moment(), 'day')) {
                            return 'Payroll Date must be updated to a future date';
                        }

                        return true;
                    },
                }}
                render={({ onChange, value }) => (
                    <ExpenseDatePicker
                        onChange={onChange}
                        disabled={isViewOnly || isInvoiceReviewLocked}
                        value={value ? moment(value) : null}
                        id={`payroll-date-${index}`}
                        label="Payroll Date"
                        required={isRequired}
                        minDate={minDate}
                        maxDate={maxDate}
                        parentTextFieldProps={{
                            error: Boolean(errors.expenseEntries?.[index]?.payrollDate),
                            helperText: errors.expenseEntries?.[index]?.payrollDate?.message,
                        }}
                        parentSx={{
                            '& .MuiInputBase-root': {
                                borderColor: !errors.expenseEntries?.[index]?.payrollDate
                                    ? 'default'
                                    : `${COLORS.LT_PEPPER} !important`,
                            },
                        }}
                    />
                )}
            />
        </Grid2>
    );
};

export default PayrollDate;
